const ActionTypes = {
  LOGIN_INIT: "LOGIN_INIT",
  LOGIN_REQUEST: "LOGIN_REQUEST",
  LOGIN_SUCCESS: "LOGIN_SUCCESS",
  LOGIN_FAILURE: "LOGIN_FAILURE"
};

export default ActionTypes;
